import React from "react";

import { isEmpty } from "lodash";
import { Trans } from "react-i18next";
import Tippy from "@tippyjs/react";
import "tippy.js/themes/light.css";

import "../../assets/CSS/partner-profile.css";
import LazyImage from "../Shared/LazyImage";
import ProductBriefCard from "../Cards/ProductBriefCard";
import { renderBulletPoints } from "../../utils/UIHelpers";
import ParameterDetailsTable from "../Tables/parameterDetailslTable";

const ProductDetailsCard = ({ model, isPreview, isReview }) => {
    const renderModels = () => {
        return (
            model?.bundleProducts &&
            model?.bundleProducts.map((model, index) => {
                return (
                    <Tippy
                        trigger="click"
                        content={<ProductBriefCard product={model} />}
                        theme="light"
                        allowHTML={true}
                        animation="scale"
                        interactive={true}
                        appendTo={document.body}
                        key={index}
                        disabled={isPreview}
                    >
                        <div className="slider-items models-slider scale-animation">
                            <div className="card-table shadow relative overflow-hidden model-box h-full">
                                <div className="flex flex-col content-start w-full">
                                    <LazyImage
                                        src={
                                            model.image ||
                                            require("../../assets/images/model-2.jpg")
                                                .default
                                        }
                                        className="mb-0"
                                        alt={`Image of ${model.label}`}
                                    />
                                    <div className="text-left mx-3 my-2">
                                        <div className="flex flex-row align-center">
                                            <h4 className="font-semibold related-models-header w-full truncate mb-2">
                                                {model.label}
                                            </h4>
                                            {!isPreview && (
                                                <h4>
                                                    <i className="fas fa-arrow-right text-primary-color-orange"></i>
                                                </h4>
                                            )}
                                        </div>
                                        <div className="text-xs related-models-content mb-2">
                                            {model.materialName}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Tippy>
                );
            })
        );
    };

    const renderBundleProducts = () => {
        return (
            !isEmpty(model?.bundleProducts) && (
                <div className="prod-title mb-6">
                    <h3>
                        <Trans i18nKey="includedModels">Included Models</Trans>
                    </h3>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-4">
                        {renderModels()}
                    </div>
                </div>
            )
        );
    };

    const renderParameters = () => {
        return (
            !isEmpty(model?.parameters) && (
                <div className="prod-title product-info-description mb-6">
                    <h3>
                        <Trans i18nKey="parametersDetails">
                            Parameters Details
                        </Trans>
                    </h3>
                    <ParameterDetailsTable
                        data={model?.parameters}
                        isReview={isReview}
                    />
                </div>
            )
        );
    };

    return (
        <>
            <div className="prod-title product-info-description mb-6">
                <h3>
                    <Trans i18nKey="description">Description</Trans>
                </h3>
                <p>{model?.description}</p>
            </div>
            <div className="prod-title product-info-what-new mb-6">
                <h3>
                    <Trans i18nKey="whatsNew">What’s new</Trans>
                </h3>
                <ul className="ml-2">{renderBulletPoints(model?.whatsNew)}</ul>
            </div>

            {!isEmpty(model?.instructions) && (
                <div className="prod-title product-info-what-new mb-6">
                    <h3>
                        <Trans i18nKey="instructions">Instructions</Trans>
                    </h3>
                    <ul className="ml-2">
                        {renderBulletPoints(model?.instructions)}
                    </ul>
                </div>
            )}

            {renderParameters()}

            {renderBundleProducts()}
        </>
    );
};

export default ProductDetailsCard;
